(function () {
  'use strict';

  const drawer   = document.getElementById('cart-drawer');
  const overlay  = document.getElementById('cart-drawer-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.openCartDrawer  = openDrawer;
  window.closeCartDrawer = closeDrawer;

  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  /* ---------------- EMPTY STATE ---------------- */
  function updateEmptyState(count) {
    const footer = document.querySelector('.cart-drawer__footer');
    const goals  = document.querySelector('.cart-drawer__goals');
    const offers = document.querySelector('.cart-offers');
    if (footer) footer.style.display = count > 0 ? '' : 'none';
    if (goals)  goals.style.display  = count > 0 ? '' : 'none';
    if (offers) offers.style.display = count > 0 ? '' : 'none';
  }

  /* ---------------- REFRESH DRAWER ---------------- */
  function refreshDrawer() {
    return fetch('/?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const doc     = new DOMParser().parseFromString(html, 'text/html');
        const newBody = doc.getElementById('cart-drawer-body');
        const oldBody = document.getElementById('cart-drawer-body');
        if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
        return fetch('/cart.js');
      })
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });
        updateEmptyState(cart.item_count);
        initUpsellDots();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        return cart;
      })
      .catch(console.error);
  }

  window.refreshDrawer = refreshDrawer;

  /* ---------------- CLICK HANDLER ---------------- */
  document.addEventListener('click', (e) => {

    // ── Cart Open ──
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    // ── Offers Toggle ──
    const toggle = e.target.closest('#cart-offers-toggle');
    if (toggle) {
      const list   = document.getElementById('cart-offers-list');
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (list) list.classList.toggle('is-open');
      return;
    }

    // ── Upsell Add to Cart ──
    const upsellBtn = e.target.closest('.cart-upsell__add');
    if (upsellBtn) {
      const variantId = upsellBtn.dataset.variantId;
      upsellBtn.disabled    = true;
      upsellBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(() => refreshDrawer())
        .then(() => openDrawer())
        .catch(() => {
          upsellBtn.textContent = 'Error';
          upsellBtn.disabled = false;
        });
      return;
    }

    // ── Qty Buttons ──
    const qtyBtn = e.target.closest('.cart-item__qty-btn');
    if (qtyBtn) {
      const key    = qtyBtn.dataset.key;
      const action = qtyBtn.dataset.action;
      const valEl  = qtyBtn.closest('.cart-item__qty').querySelector('.cart-item__qty-val');
      let qty = parseInt(valEl.textContent, 10);
      qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(() => refreshDrawer())
        .catch(console.error);
      return;
    }

    // ── Remove Button ──
    const removeBtn = e.target.closest('.cart-item__remove');
    if (removeBtn) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: removeBtn.dataset.key, quantity: 0 })
      })
        .then(() => refreshDrawer())
        .catch(console.error);
      return;
    }

  });

  /* ---------------- CHANGE HANDLER ---------------- */
  document.addEventListener('change', (e) => {

    // ── Cart Item Variant Change ──
    const variantSelect = e.target.closest('.cart-item__variant-select');
if (variantSelect) {
  const oldKey       = variantSelect.dataset.cartKey;
  const newVariantId = parseInt(variantSelect.value, 10);

  const cartItem = variantSelect.closest('.cart-item');
  const qtyEl    = cartItem?.querySelector('.cart-item__qty-val');
  const qty      = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

  // Pehle cart se current item ki properties nikalo
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const currentItem = cart.items.find(i => i.key === oldKey);
      const properties  = currentItem ? currentItem.properties : {};

      // Step 1: purana remove
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: oldKey, quantity: 0 })
      })
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: newVariantId,
          quantity: qty,
          properties: properties  // ✅ properties saath bhej rahe hain
        })
      }));
    })
    .then(() => refreshDrawer())
    .catch(console.error);
  return;
}

    // ── Upsell Variant Select — price + variantId update ──
    const upsellSelect = e.target.closest('.cart-upsell__variant-select');
    if (upsellSelect) {
      const selected = upsellSelect.options[upsellSelect.selectedIndex];
      const card     = upsellSelect.closest('.cart-upsell__card');
      const priceEl  = card?.querySelector('.cart-upsell__price-current');
      const addBtn   = card?.querySelector('.cart-upsell__add');
      if (priceEl) priceEl.textContent = '₹' + selected.dataset.price;
      if (addBtn)  addBtn.dataset.variantId = upsellSelect.value;
      return;
    }

  });

  /* ---------------- UPSELL DOTS ---------------- */
  function initUpsellDots() {
    const slider = document.getElementById('cart-upsell-slider');
    const dotsEl = document.getElementById('cart-upsell-dots');
    if (!slider || !dotsEl) return;

    const cards = slider.querySelectorAll('.cart-upsell__card');
    if (!cards.length) return;

    dotsEl.innerHTML = '';
    cards.forEach((_, i) => {
      const dot = document.createElement('span');
      dot.className     = 'dot' + (i === 0 ? ' active' : '');
      dot.dataset.index = i;
      dotsEl.appendChild(dot);
    });

    dotsEl.onclick = (e) => {
      const dot = e.target.closest('.dot');
      if (!dot) return;
      const card = cards[parseInt(dot.dataset.index, 10)];
      if (!card) return;
      slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      dotsEl.querySelectorAll('.dot').forEach(d => d.classList.remove('active'));
      dot.classList.add('active');
    };
  }

  initUpsellDots();

})();